<template>
  <v-text-field ref="textField" hide-details="auto" flat density="compact" variant="outlined">
    <template #prepend-inner v-if="Boolean($slots['prepend-inner'])">
      <slot name="prepend-inner" />
    </template>
    <template #append-inner v-if="Boolean($slots['append-inner'])">
      <slot name="append-inner" />
    </template>
    <template #append v-if="Boolean($slots.append)">
      <slot name="append" />
    </template>
    <template #message="{ message }">
      <div class="d-flex align-center gap-2">
        <i-custom-warning-circle />
        <div>{{ message }}</div>
      </div>
    </template>
  </v-text-field>
</template>

<script>
export default {
  props: {
    colorMode: {
      type: String,
      default: "post",
      validator: (value) => ["post", "wall", "top-bar"].includes(value)
    }
  },
  data() {
    return {
      counterColor: `var(--${this.colorMode}-detail)`,
      placeholderTextColor: `var(--${this.colorMode}-text-40)`,
      textColor: `var(--${this.colorMode}-text)`,
      borderAndDetailsColor: `var(--${this.colorMode}-detail-20)`
    }
  },
  computed: {
    inputElement() {
      return this.$refs.textField.$el.querySelector("input")
    }
  },
  methods: {
    focus() {
      this.inputElement.focus()
    },
    blur() {
      this.inputElement.blur()
    },
    select() {
      this.inputElement.focus()
      this.inputElement.select()
    },
    async validate() {
      return await this.$refs.textField.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.v-input {
  :deep(.v-messages__message) {
    transition: 0.2s ease;
    transition-delay: 0.1s;
  }

  :deep(.v-field) {
    min-height: 40px;
    fieldset {
      display: none;
    }
  }

  :deep(.v-text-field__details) {
    padding: 0 !important;
  }

  :deep(.v-input__control) {
    min-height: 0px;
    color: currentColor;
  }

  :deep(.v-field__prepend-inner) {
    padding-right: 8px;
  }

  :deep(.v-field__prepend-inner),
  :deep(.v-field__append-inner) {
    margin: 0 auto;
    padding-left: 0;
    align-self: center;
  }

  :deep(.v-field__outline) {
    color: v-bind(borderAndDetailsColor);
    --v-field-border-width: 1px !important;
    --v-field-border-opacity: 1 !important;

    label {
      color: var(--post-text);
    }
  }

  :deep(.v-counter) {
    color: v-bind(counterColor);
  }

  :deep(.input::placeholder) {
    color: v-bind(placeholderTextColor) !important;
  }

  // https://stackoverflow.com/a/62624824
  :deep(input:-webkit-autofill) {
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: v-bind(textColor) !important;
  }

  :deep(.v-field) {
    color: v-bind(textColor);
  }
}
</style>
